























import { defineComponent } from '@vue/composition-api'
import MovieList from '@/components/MovieList/MovieList.vue'
import { MovieRecommendType } from '@/datas/MovieData'

// ================================
// Props
// ================================
export type MovieInfoRecommendationProps = {
  recommends: MovieRecommendType[];
}

// ================================
// Component
// ================================
export default defineComponent({
  name: 'MovieInfoRecommendation',
  components: { MovieList },
  props: ['recommends', 'fetch'],
  setup (props: MovieInfoRecommendationProps) {
    return {
      props
    }
  }
})
